import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { FAQS } from '../lib/site';
import { Reveal } from './Reveal';

export const FAQSection = () => {
    return (
        <section data-testid="faq-section" className="py-24 md:py-32 bg-background">
            <div className="container-axion grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
                <div className="md:col-span-5">
                    <Reveal>
                        <div className="overline">FAQ</div>
                        <h2 className="text-4xl md:text-5xl font-outfit font-medium tracking-tight mt-4 leading-[1.05]">
                            Quietly answered.
                        </h2>
                        <p className="text-muted-foreground mt-5 text-[15px] leading-relaxed max-w-md">
                            The things our clients ask before their first booking.
                            Anything missing? Drop us a line — we reply within the hour.
                        </p>
                    </Reveal>
                </div>

                <Reveal delay={140} className="md:col-span-7">
                    <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                        {FAQS.map((f, i) => (
                            <AccordionItem
                                key={f.q}
                                value={`faq-${i}`}
                                className="border-border"
                                data-testid={`faq-item-${i}`}
                            >
                                <AccordionTrigger className="text-left font-outfit text-[17px] py-6 hover:no-underline">
                                    <span className="flex items-center gap-4">
                                        <span className="text-xs text-accent font-mono w-6">{String(i + 1).padStart(2, '0')}</span>
                                        {f.q}
                                    </span>
                                </AccordionTrigger>
                                <AccordionContent className="text-muted-foreground text-[15px] leading-relaxed pl-10 pb-6">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
            </div>
        </section>
    );
};
